import { ApiService } from './api/api'
import { processParams } from '@/utils/params'

export default class MasterGroupService {
	private apiService

	constructor() {
		this.apiService = new ApiService(true)
	}

	/**
	 * Get all master groups
	 * @returns Promise
	 */
	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/master-groups`, { params: processParams(params) })
	}

	/**
	 * Get a master group
	 * @param code String
	 * @param params Record<string, string | string[]
	 * @returns Promise
	 */
	get(code: string, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/master-groups/${code}`, { params: processParams(params) })
	}
}
